import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { ApiKey } from '@models/common.model';
import { ApiKeyService } from '@services/ApiKey.service';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-apikeys',
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    UiModule
  ],
  templateUrl: './apikeys.html',
  styleUrl: './apikeys.css',
})
export class Apikeys {
  //services
  readonly router=inject(Router);
  readonly keysS=inject(ApiKeyService)

  //data
  readonly keys=signal<ApiKey[]>([]);
  readonly app=signal<string>(null);

  //ui
  readonly loading=signal(false);
  readonly error=signal<string>(null);
  readonly msg=signal<string>(null);

  constructor(){
    this.loading.set(true);
    this.keysS.apiKeyList()
      .subscribe(keys => {
        this.keys.set(keys);
        this.loading.set(false);
      })
  }

  getClass(key: ApiKey){
    return {
      'badge-error': key.state=='disabled',
      'badge-success': key.state=='valid'
    };
  }

  addApiKey(){
    this.loading.set(true);
    this.keysS.addApiKey(this.app())
      .subscribe({
        next: key => {
          this.keys.set([...this.keys(), key]);
          this.msg.set('Api Key ajoutée.')
          this.loading.set(false);
        },
        error: e =>{
          this.error.set(e);
          this.loading.set(false);
        }
      });
  }

  disableKey(key: ApiKey){
    this.loading.set(true);
    this.resetMsg();
    this.keysS.disabledApiKey(key.ident)
      .subscribe(result => {
        key.state='disabled';
        this.loading.set(false);
      });
  }

  removeKey(key: ApiKey){
    this.loading.set(true);
    this.resetMsg();
    this.keysS.removeApiKey(key.ident)
      .subscribe(() => {
        this.keys().splice(this.keys().findIndex(k => k.ident==key.ident), 1);
        this.keys.set([...this.keys()]);
        this.loading.set(false);
      });
  }

  resetMsg(){
    this.msg.set(null);
    this.error.set(null);
  }
}
